import { Injectable } from '@angular/core';
import { Media } from '@digilize/shared/definitions/src';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LogoState {
  private _logo = new BehaviorSubject(null);
  logo$ = this._logo.asObservable();
  get logo() {
    return this._logo.value;
  }
  set logo(logo: Media) {
    this._logo.next(logo);
  }
  private _shopWebsite = new BehaviorSubject<string>(null);
  shopWebsite$ = this._shopWebsite.asObservable();
  get shopWebsite() {
    return this._shopWebsite.value;
  }
  set shopWebsite(shopWebsite: string) {
    this._shopWebsite.next(shopWebsite);
  }
}
